<template>
<form class="profile"  @submit.prevent="EditAddress($event)">
    <h2 class="form-title">Mis direcciones</h2>
    <table class="ui table">
        <thead>
            <tr>
                <th>Direcciones registradas</th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <span v-if="currentCustomerAddresses !== null && currentCustomerAddresses.length>0"> 
                    <span v-for="(data,index) in currentCustomerAddresses" :key="index" >
                        <td><i class="fas fa-times pointer" @click="DeleteAddress(data.id)" style="color:var(--light-blue)"></i></td>
                        <td class="pointer" @click="AddShippingAddress(data.id)">{{data.addressAsString}}</td>
                    </span>
                </span>
                <span v-else>
                    <span>
                        <td>Aun no se registran direcciones</td>
                    </span>
                </span>
            </tr>
        </tbody>
    </table>
    <input class="profile-control left" hidden name="latitude" id="latitude" @change="UpdateCordsPositions" />
    <input class="profile-control left" hidden name="longitude" id="longitude" @change="UpdateCordsPositions" />
    <input class="profile-control left" type="text" required name="street" id="street" placeholder="Calle" />
    <input class="profile-control left" type="text" required name="number" id="number" placeholder="Número exterior" />
    <input class="profile-control left" type="text" name="interiorNumber"  id="interiorNumber" placeholder="Número interior" />
    <select class="profile-control left" required name="neighborhood" id="neighborhood">>
        <option value selected disabled hidden>Seleccione la colonia</option>
        <option value="66444">Colonia inventada</option>
    </select>
    <input class="profile-control left" type="text" required name="referenceStreets" id="referenceStreets" placeholder="Entre calles" />
    <input class="profile-control left" type="text" required name="comments" id="comments" placeholder="Comentarios que nos ayuden a identificar el domicilio" />
    <div class="mid-container">
        <button type="button" class="ui blue button wide" @click="LoadAddressInMap()" style="margin-bottom: 10px;"> Cargar dirección en el mapa<i class="fa fa-map-marker"></i></button>
    </div>
    <div id="map"></div>
    <GmapMap v-bind:center="cords" :zoom="15" map-type-id="terrain" style="width: 100%; height: 300px" align="center">
        <GmapMarker ref="marker" name="marker" :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="true" @click="Marker($event)" @drag="UpdateCoordinates" />
    </GmapMap>
    <div class="mid-container">
        <button style="margin-top:.5rem" class="ui blue button wide" id="AddAddress" name="AddAddress" type="submit" >Agregar dirección</button>
    </div>
</form>
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAgXYwmEyjyrfh05bQvYAchiB33tLDAIQ8"></script>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    methods:{
    LoadAddressInMap() {
        let geocoder = new google.maps.Geocoder()
        let neihborhood = document.getElementById("neighborhood").value
        let address = document.getElementById("street").value + ' #' + document.getElementById("number").value + ',' + neihborhood + ' ' + document.getElementById("referenceStreets").value +' Monterrey Nuevo Leon'
        if (address != '') {
            geocoder.geocode({'address': address}, function (results, status) {
                    if(status == 'OK'){
                        document.getElementById("latitude").value = results[0].geometry.location.lat()
                        document.getElementById("longitude").value = results[0].geometry.location.lng()
                        let element = document.getElementById("latitude")
                        let event = new Event('change')
                        element.dispatchEvent(event)
                    }
                });
        }
    },
    UpdateCoordinates(location){
        document.getElementById("latitude").value = location.latLng.lat() 
        document.getElementById("longitude").value = location.latLng.lng()
    },
    UpdateCordsPositions(){
        let cordsPosition = {lat:parseFloat(document.getElementById("latitude").value), lng:parseFloat(document.getElementById("longitude").value)}
        let cords = cordsPosition
 
        let markers = [{position:cordsPosition}]

        this.$store.commit('StateAssign',{cords:cords})
        this.$store.commit('StateAssign',{markers:markers})

    },
    ...mapActions(['EditAddress','DeleteAddress','AddShippingAddress'])
    },
    computed:{
       ...mapState([
      'cords',
      'markers',
      'currentCustomerAddresses',
      'userFavorites'
    ])
    }

}
</script>